module.exports={
	"Form": "ProductCreateManifest",
	"Scope": "Product-Create",
	"Descriptors":
	{
		"ProductDetails.Name":
		{
			"Name": "Name",
			"Hash": "Product-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Product-Create-Identity",
				"Group": "Product-Create-Identity"
			}
		},
		"ProductDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Product-Create-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Product-Create-Identity",
				"Group": "Product-Create-Identity"
			}
		},
		"ProductDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Product-Create-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Product-Create-Identity",
				"Group": "Product-Create-Identity"
			}
		},
		"ProductDetails.AcceptanceMethod":
		{
			"Name": "Acceptance Method",
			"Hash": "Product-Create-AcceptanceMethod",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details"
			}
		},
		"ProductDetails.ProductCategory":
		{
			"Name": "Product Category",
			"Hash": "Product-Create-ProductCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details"
			}
		},
		"ProductDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "Product-Create-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details"
			}
		},
		"ProductDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "Product-Create-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details"
			}
		},
		"ProductDetails.Comments":
		{
			"Name": "Comments",
			"Hash": "Product-Create-Comments",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 12,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details"
			}
		},
		"ProductDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Product-Create-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"ProductDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Product-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-Create-Details",
				"Group": "Product-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Product-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Product-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Product-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Product-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
